import { render } from "./CustomerRMName.vue?vue&type=template&id=768a90f4&scoped=true"
import script from "./CustomerRMName.vue?vue&type=script&lang=js"
export * from "./CustomerRMName.vue?vue&type=script&lang=js"

import "./CustomerRMName.vue?vue&type=style&index=0&id=768a90f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768a90f4"],['__file',"src/components/CustomerRMName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "768a90f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('768a90f4', __exports__)) {
    api.reload('768a90f4', __exports__)
  }
  
  module.hot.accept("./CustomerRMName.vue?vue&type=template&id=768a90f4&scoped=true", () => {
    api.rerender('768a90f4', render)
  })

}


export default __exports__